export const PROFILE_CACHE_PREFIX = 'mackinac:profile:'

export function getProfileCacheKey(
    protocol: string,
    session: { did: string } | null,
    mastodonSession: { instance_url: string; account: { username: string } } | null,
    pixelfedSession?: { instance_url: string; account: { username: string } } | null
): string | null {
    if (protocol === 'bluesky' && session) {
        return `${PROFILE_CACHE_PREFIX}bluesky:${session.did}`
    }
    if (protocol === 'mastodon' && mastodonSession) {
        const host = mastodonSession.instance_url.replace(/^https?:\/\//, '').replace(/\/$/, '')
        return `${PROFILE_CACHE_PREFIX}mastodon:${host}:${mastodonSession.account.username}`
    }
    if (protocol === 'pixelfed' && pixelfedSession) {
        return `${PROFILE_CACHE_PREFIX}pixelfed:${pixelfedSession.instance_url}:${pixelfedSession.account.username}`
    }
    return null
}
